<div class="main-container">
  <div class="logo-backBtn-container">

    <div class="logo-container">
      <div class="logo">
        <img width="205px" src="../../../../../assets/Primary-dark.svg" alt="e11even logo" />
      </div>
    </div>
    <span class="empty"> </span>
  </div>
  <div class="passcode-box-container">
    <div class="passcode-box">
      <div *ngIf="getCheckIfRegistered$ | async as isRegisteredUser">
        <div *ngIf="!isRegisteredUser.registrationRequired; else isRegistered">
          <div class="text-container">
            <h1 class="title-1">WELCOME BACK</h1>
            <h1 class="title-2">Enter your Hayrick passcode</h1>
          </div>
        </div>
        <ng-template #isRegistered>
          <div class="text-container">
            <h1 class="title-1">Let’s Get Started</h1>
            <h1 class="title-2">Create Passcode</h1>
            <h1 class="text-3">Let’s create your sign-in passcode. <br />Your passcode should consist of 4 digits</h1>
          </div>
        </ng-template>
      </div>

      <div class="password-input-container">
        <form [formGroup]="passwordForm">
          <div class="p-field">
            <span class="p-float-label">
              <input
                required
                pInputText
                maxlength="4"
                formControlName="passcode"
                id="passcode"
                class="password-input"
                type="password"
                name="password"
                (keyup.enter)="signupSetPasscode()"
              />
              <label for="inputtext">Passcode</label>
            </span>
          </div>
        </form>
      </div>
      <div class="submit-btn">
        <button [disabled]="!passwordForm.valid" (click)="signupSetPasscode()" class="button">SUBMIT</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isRegistrationLoading$ | async as isRegistrationLoading">
  <div *ngIf="isRegistrationLoading"></div>
</div>
